// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-strength {
  margin-top: 8px;
}

.password-strength-bar {
  width: 100%;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
}

.password-strength-fill {
  height: 100%;
  transition: width 0.3s ease, background-color 0.3s ease;
}

.password-strength-label {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
}

.password-requirements {
  font-size: 11px;
  color: #666;
  margin-top: 8px;
}

.password-requirements > div {
  margin: 4px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.requirement-met {
  color: #27ae60;
}

.requirement-unmet {
  color: #999;
}

`, "",{"version":3,"sources":["webpack://./src/components/PasswordStrength.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".password-strength {\n  margin-top: 8px;\n}\n\n.password-strength-bar {\n  width: 100%;\n  height: 6px;\n  background-color: #e0e0e0;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.password-strength-fill {\n  height: 100%;\n  transition: width 0.3s ease, background-color 0.3s ease;\n}\n\n.password-strength-label {\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.password-requirements {\n  font-size: 11px;\n  color: #666;\n  margin-top: 8px;\n}\n\n.password-requirements > div {\n  margin: 4px 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.requirement-met {\n  color: #27ae60;\n}\n\n.requirement-unmet {\n  color: #999;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
